import {css} from "styled-components";

export const PanelFormStyle = css`
  /* Panel Form */
  form.panel-form {
    textarea {
      margin-top: 4px;
    }
    
    .panel-content {
      .ant-collapse-content > .ant-collapse-content-box {
        padding: 0;
      }
    }

    .panel-row {
      margin-bottom: 8px;

      @media only screen and (width <= 767px) {
        margin-bottom: 12px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .panel-item-col {
        /* added v4 version */
        .ant-legacy-form-item {
          margin-bottom: 0;

          .ant-legacy-form-item-label {
            @media only screen and (width <= 767px) {
              padding-bottom: 4px;
            }
          }

          .ant-upload-select {
            margin-right: 0;
            margin-bottom: 0;
          }
        }

        .ant-form-item {
          margin: 4px 0;
          margin-bottom: 0;

          .ant-form-item-label {
            @media only screen and (width <= 767px) {
              padding-bottom: 4px;
            }
          }

          .ant-upload-select {
            margin-right: 0;
            margin-bottom: 0;
          }

          /* nested form items - revert margins */
          .ant-form-item {
            margin: 0;
          }
        }

         /* &.lazada-panel-form-item {
           .ant-form-item-label {
             @media only screen and (min-width: 576px) {
               padding-bottom: 22px;
             }
             white-space: normal;
           }
         } */
      }

      .upload-form-item {
        .ant-legacy-form-item-control {
          line-height: 21px;
        }
      }

      .panel-desc-col {
        padding: 10px 14px 0;
        color: rgba(0, 0, 0, 45%);

        p {
          margin-bottom: 8px;
        }

        @media only screen and (width <= 767px) {
          padding: 4px 0 0;

           /* &.lazada-panel-form-item {
               @media (min-width: 576px) {
                 margin-top: -21px;
             }
           } */
        }

        &.form-design {
          padding: 5px 14px 1px;

          @media only screen and (width <= 767px) {
            padding: 4px 0 0;
          }

          @media only screen and (width <= 576px) {
            padding: 8px 0 0;
          }
        }
      }
    }
  }
`;
